import { UserProfilePhoto } from "@/components/ui/UserProfilePhoto/UserProfilePhoto";
import type { useUserDirectory } from "@/hooks/use-user-directory";
import type { Matter, MatterTeammate } from "@/lib/types";
import { formatUsersName } from "@/lib/utils/format";

export function createPersonnelIdentity(
  matter: Matter,
  roster: MatterTeammate[],
  users: ReturnType<typeof useUserDirectory>["users"],
) {
  const userFor = (userId: string) =>
    matter.assignees.find((item) => item.user.id === userId)?.user ??
    roster.find((item) => item.userId === userId) ??
    users.find((item) => item.id === userId);
  const nameFor = (userId: string) => {
    const user = userFor(userId);
    return (user && formatUsersName(user)) || "User";
  };
  const profileFor = (userId: string) => {
    const user = userFor(userId);
    const profile =
      user && "userId" in user
        ? {
            id: userId,
            firstName: user.firstName,
            lastName: user.lastName,
            profilePicturePresignedUrlKey: undefined,
          }
        : user;
    return profile ? (
      <UserProfilePhoto user={profile} />
    ) : (
      <span className="bg-muted flex size-9 items-center justify-center rounded-full text-sm">
        {nameFor(userId).charAt(0)}
      </span>
    );
  };
  return { nameFor, profileFor };
}
